export const DATE_FORMAT_REGEX = /^\d{2}\/\d{2}\/\d{4}$/;
